import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Box,
    Button,
    Divider,
    Stack,
} from '@mui/material';
import { MdCancel } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import "../../../Components/ModalCss/TableDataViewModal.css";

import actions from "../../../ReduxStore/actions/index";
import { toast, ToastContainer } from 'react-toastify';
import { clearTableGetId } from '../../../ReduxStore/Slices/TableId/TableIdGetSlice';
import { clearCustomerId } from '../../../ReduxStore/Slices/Operator/customerSlice';

const CountryViewModal = ({ open, onClose, modalViewHeadingName }) => {
    const dispatch = useDispatch();
    // const TableId = useSelector((state) => state.Table.TableId);
    const TableId = useSelector((state) => state.Table.TableId);

    const { getCountryWithDetailsById } = useSelector((state) => state?.getCountryWithDetailsById);
    const [countryData, setCountryData] = useState(null);


    useEffect(() => {
        if (!open) return;

        const fetchData = async () => {
            if (TableId) {
                const data1 = { data: {}, method: "get", apiName: `getCountryWithDetailsById/${TableId}` };
                const response = await dispatch(actions.GETCOUNTRYWITHDETAILSBYID(data1));
                setCountryData(response?.payload?.data || null);
            }
        };
        fetchData();
    }, [dispatch, TableId, open]);

    return (
        <Dialog
            open={open}
            // onClose={onClose}
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                "& .MuiPaper-root": {
                    borderRadius: "14px",
                },
            }}
        >
            {/* <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} theme="dark" /> */}

            {/* Header */}
            <Box sx={{ position: 'relative' }}>
                {/* Dialog Header */}
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            dispatch(clearTableGetId(null))
                            dispatch(clearCustomerId(null))

                        }}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'text.secondary',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Typography className="custom-title-text" color="white">
                            Country Details
                        </Typography>
                    </DialogTitle>
                </Box>
            </Box>


            {/* Body */}
            <DialogContent dividers>
                {countryData ? (
                    <>
                        {/* Country Details */}
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                            Country: {countryData.country_name}
                        </Typography>

                        <Divider sx={{ mb: 2 }} />

                        {/* States & Cities */}
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>States & Cities</Typography>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold' }}>State Name</TableCell>
                                        <TableCell sx={{ fontWeight: 'bold' }}>Cities</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {countryData.states.length > 0 ? (
                                        countryData.states.map((state) => (
                                            <TableRow key={state.state_id}>
                                                <TableCell>{state.state_name}</TableCell>
                                                <TableCell>
                                                    {state.cities.length > 0
                                                        ? state.cities.map((city) => city.city_name).join(', ')
                                                        : 'No Cities'}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={2} align="center">
                                                No States Available
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {/* KYC Details */}
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 3 }}>KYC Documents</Typography>
                        <Stack spacing={1} sx={{ mt: 1 }}>
                            {countryData.kycs.length > 0 ? (
                                countryData.kycs.map((kyc) => (
                                    <Typography key={kyc.kyc_id}>• {kyc.kyc_name}</Typography>
                                ))
                            ) : (
                                <Typography>No KYC Documents Available</Typography>
                            )}
                        </Stack>
                    </>
                ) : (
                    <Typography>No Data Available</Typography>
                )}
            </DialogContent>

            {/* Footer */}
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                    // type="submit"
                    onClick={() => {
                        onClose()
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))

                    }}

                    variant="contained"
                    sx={{
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        boxShadow: "none",
                        padding: { xs: "0px 20px", md: "0px 40px" },
                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "#C38F51",
                        "&:hover": { backgroundColor: "#3B4056" },
                    }}
                >
                    Close
                </Button>
            </Box>
        </Dialog>
    );
};

export default CountryViewModal;
